import "./banner.css";
import bg from "../../assets/img/banner/banner_bg.webp";
import quote1 from "../../assets/img/banner/quote1.svg";
import quote2 from "../../assets/img/banner/quote2.svg";

export default function banner() {
  return (
    <section className="Banner">
      <article>
        <img src={bg} alt="" />
        <p>
          <img src={quote1} alt="" className="quote first" />
          Vous l'aurez donc compris, nous sommes une société avec de vraies
          valeurs humaines,
          <br /> Nous mettons tout en oeuvre pour que la relation de partenariat 
          qui nous lie
          <br /> avec vous soit la meilleure possible, avec sincerité et proximité
          <img src={quote2} alt="" className="quote second" />
        </p>
      </article>
    </section>
  );
}
